import { isWhiteLabel } from 'app/utils/helpers';
import { WhiteLabel } from 'app/types/white-labels';
import { withErrorBoundary } from 'app/components/error-boundary';
import { OnboardingLayout } from 'app/components/onboarding/layout';
import { Column } from 'app/design/primitives/box';
import { useDeviceHeight } from 'app/hooks/use-device-size';
import { useContactInformationHeaderOptions } from 'app/screens/onboarding/hooks/use-contact-information-header-options';
import { useContactInformationScreen } from 'app/screens/onboarding/hooks/use-contact-information-screen';
import { ContactInformationSteps } from 'app/screens/onboarding/contact-information-steps';
import { SignUpSheet, SignUpSource } from 'app/screens/onboarding/signup';
import type { NavigationScreen } from 'app/types/navigation';

const ContactInformationScreenComponent: NavigationScreen<'contact-information'> = ({ route, navigation }) => {
  const s = useContactInformationScreen({ navigation, route });

  useContactInformationHeaderOptions(navigation, {
    headerVariant: 'standard',
    hideCross: route.params?.hideCross,
    onBackPress: s.onBackPress,
    step: s.step,
  });

  const deviceHeight = useDeviceHeight();

  return (
    <OnboardingLayout
      activeColor={s.progressActiveColor}
      primary={{
        disabled: !s.formState.isValid,
        loading: s.flowRest.isGeoCodeAddressFetching,
        onPress: s.flowRest.onPrimaryPress,
      }}
      titleKey={isWhiteLabel(WhiteLabel.Refrain) ? 'festival:signupTitle' : `title${s.tSuffix}`}
    >
      <Column
        backgroundColor={isWhiteLabel(WhiteLabel.Refrain) ? undefined : 'surface.primary'}
        borderRadius="radius.lg"
        padding={isWhiteLabel(WhiteLabel.Refrain) ? 'spacing.general.0' : 'spacing.general.x4'}
      >
        <ContactInformationSteps
          control={s.control}
          deviceHeight={deviceHeight}
          flow={s.flowRest}
          t={s.t}
          tAPI={s.tAPI}
          tSuffix={s.tSuffix}
          variant="highlight"
        />
        <SignUpSheet
          onLogin={() => navigation.reset({ routes: [{ name: 'main' }] })}
          state={s.signUpSheetState}
          source={SignUpSource.ContactInformation}
        />
      </Column>
    </OnboardingLayout>
  );
};

export const ContactInformationScreen: NavigationScreen<'contact-information'> = withErrorBoundary(
  ContactInformationScreenComponent,
);
